import React from 'react'; // Импорт библиотеки React для создания компонентов
import ReactDOM from 'react-dom/client'; // Импорт ReactDOM для рендеринга приложения в DOM браузера
import App from './App'; // Импорт главного компонента приложения

// Получаем ссылку на HTML-элемент с id="root" из файла index.html
const rootElement = document.getElementById('root');

// Проверка безопасности: если элемент не найден, выбрасываем ошибку
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Создаем "корень" React приложения, привязываясь к найденному элементу
const root = ReactDOM.createRoot(rootElement);

// Рендерим (отрисовываем) приложение
root.render(
  // StrictMode - специальный режим для разработки, который выявляет потенциальные проблемы
  // и дважды вызывает эффекты для проверки чистоты функций
  <React.StrictMode>
    <App /> {/* Вызов главного компонента App */}
  </React.StrictMode>
);